import { useEffect } from 'react'
import { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import { ITimeRange } from 'types/datetime'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { IBand, IRateAPI } from 'apps/marketplace/store/contractLanes/types'
import { getCarrierCapacity } from 'apps/marketplace/utils/helpers/rates'

interface IDispatcher {
  userType: string
}

interface ICarrierCapacity {
  values?: {}
  loading?: boolean
  pickupCity?: string
  pickupStateCode?: string
  pickupRadius?: number
  [key: string]: number | boolean | string | {} | undefined
}

export interface ChangeRateData {
  actionType: string
  carrierId: number
  carrierName: string
  rateType: string
  rate: string
  buttonClicked: boolean
  equipmentId: number | string
  isDatMarketApplicable: boolean
  loadType: string
  expirationType: string
  expirationDate: string | null
  startType: string
  startDate: string
  dispatcher: string
  dispatcherName: string
  displayUserCreation: boolean
  pickupLocation: ILocationSuggestion
  deliveryLocation: ILocationSuggestion
  radiusRates: IBand[]
  carrierCapacity: ICarrierCapacity
  dispatcherList: IDispatcher[]
  pickupTimePreferences: ITimeRange[]
  pickupTimeType: string
  pickupTimeEveryday: {
    startTime?: string | null
    endTime?: string | null
  }
  deliveryTimePreference: string
  shipperId: string
  shipperName: string
  isShipperExclusive: boolean
  user: {
    [key: string]: string
  }
  pickupRadiusMiles: number
  deliveryRadiusMiles: number
  isOnlyDropTrailer: boolean
}

const fetchCarrierCapacity = async (
  carrierId: number,
  city: string,
  stateCode: string,
  changeRateData: (changes: Partial<ChangeRateData>) => void
) => {
  changeRateData({ carrierCapacity: { values: {}, loading: true } })

  const { carrierApplicationOfferLimits } = await callApi({
    endpoint: ENDPOINTS.carriers,
    id: carrierId,
    group: 'offer_limits',
    params: { filters: { city, stateCode } },
  })

  changeRateData({
    carrierCapacity: { ...getCarrierCapacity(carrierApplicationOfferLimits), loading: false },
  })
}

export const useCarrier = (
  rateData: IRateAPI,
  changeRateData: (changes: Partial<ChangeRateData>) => void,
  dialogOpen: boolean
) => {
  const { carrierId, pickupLocation } = rateData || {}

  useEffect(() => {
    if (rateData) {
      const { contractId, pickupLocation: { city, state: stateCode } = {} } = rateData
      if (dialogOpen && !contractId && carrierId && city && stateCode) {
        fetchCarrierCapacity(carrierId, city, stateCode, changeRateData)
      }
    }
  }, [carrierId, pickupLocation, dialogOpen])
}
